<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModal()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Investimento
            </span>
        </b-button>
		<b-modal
			v-model="showModal"
			id="modalInserirInvestimento"
			hide-footer
		>
			<div slot="modal-title">
				Investimento -
				<b-badge variant="warning">Inserir</b-badge>
			</div>
			<investimento-form
				tipoOperacao="i"
				:showModal="showModal"
				@modalFechado="showModal = false"
				@obterInvestimentosAtualizados="$emit('obterInvestimentosAtualizados')"
				:contrato="contrato"
			></investimento-form>
		</b-modal>
    </div>
</template>

<script>
import InvestimentoForm from './InvestimentoForm'

export default {
	components: {
		InvestimentoForm
	},

	props: {
		contrato: {
			type: Object,
			default: () => ({})
		}
	},
	
	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
